const EXPO_PUBLIC_TARGET_DATABASE_NAME = ``
const WEBAPP_BASE_URL= ``
const API_URL = ``

export {
    API_URL,
    EXPO_PUBLIC_TARGET_DATABASE_NAME,
    WEBAPP_BASE_URL,
}